// DriftAxis — per-fund diverging bar showing how far actual sits above/below
// the election target, around a centered zero axis. Screen-specific to
// Rebalance; a diverging-from-center axis has no reusable equivalent.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { formatPercent } from '../../../utils/format';

const AXIS_SCALE = 12; // px-of-half-track per 1% of drift (matches prototype)

export function DriftAxis({ allocations }) {
  return (
    <div className="ma-drift-table">
      {allocations.map((a) => {
        const drift = a.actual - a.election;
        const tone = drift === 0 ? 'flat' : drift > 0 ? 'pos' : 'neg';
        const width = `${Math.min(50, Math.abs(drift) * AXIS_SCALE)}%`;
        return (
          <div key={a.ticker} className="ma-drift-row">
            <span className="ma-fund-dot" style={{ background: a.color }} aria-hidden="true" />
            <span className="ma-drift-tkr">{a.ticker}</span>
            <div className="ma-drift-axis">
              <div className="ma-drift-axis__center" aria-hidden="true" />
              <div
                className={cx('ma-drift-axis__bar', tone)}
                style={
                  drift >= 0
                    ? { width, left: '50%' }
                    : { width, right: '50%' }
                }
              />
            </div>
            <span className="ma-drift-actual">
              {a.actual}% <span className="ma-muted">of {a.election}%</span>
            </span>
            <span className={cx('ma-drift-mini', tone)}>
              {drift === 0 ? '0%' : formatPercent(drift, { digits: 0, signed: true })}
            </span>
          </div>
        );
      })}
    </div>
  );
}

DriftAxis.propTypes = {
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      ticker: PropTypes.string,
      election: PropTypes.number,
      actual: PropTypes.number,
      color: PropTypes.string,
    }),
  ).isRequired,
};

export default DriftAxis;
